import React from 'react'
import { InstagramEmbed, XEmbed, YouTubeEmbed } from 'react-social-media-embed'

function PreViewVideo(props) {
  const { previewVideo, handleSubmit } = props
  const validateUrl = (url, type) => {
    let pattern
    switch (type) {
      case 'instagram':
        pattern = /^(https?:\/\/)?(www\.)?instagram\.com\/.*$/
        break
      case 'X':
        pattern = /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/.*$/
        break
      case 'youtube':
        pattern = /^(https?:\/\/)?(www\.)?youtube\.com\/.*$/
        break
      default:
        return false
    }

    return pattern.test(url)
  }

  return (
    <>
      {/* Preview */}
      {previewVideo && previewVideo.path && previewVideo.videoPlatform && (
        <div
          style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '10px' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
            <div>Preview</div>
            {previewVideo.videoPlatform === 'X' && previewVideo.path && (
              <XEmbed url={previewVideo.path} width={325} height={220} />
            )}
            {previewVideo.videoPlatform === 'youtube' && previewVideo.path && (
              <YouTubeEmbed url={previewVideo.path} width={325} height={220} />
            )}
            {previewVideo.videoPlatform === 'instagram' && previewVideo.path && (
              <InstagramEmbed url={previewVideo.path} width={325} height={220} />
            )}
          </div>
          <div style={{ alignSelf: 'center' }}>
            {previewVideo.videoPlatform && previewVideo.path && (
              <button
                type='button'
                onClick={() => handleSubmit()}
                className='btn btn-primary'
                disabled={
                  !(
                    previewVideo.videoPlatform &&
                    previewVideo.path &&
                    previewVideo.title &&
                    validateUrl(previewVideo.path, previewVideo.videoPlatform)
                  )
                }
                // style={{ width: 'auto', height: 'auto', justifySelf: 'center' }}
              >
                ok
              </button>
            )}
          </div>
          {/* Add other platform previews here */}
        </div>
      )}
    </>
  )
}

export default PreViewVideo
